'use client'

/**
 * Wunschset is currently open to everyone, regardless of login or club
 * membership.
 */
export const useCanSeeWunschset = (): boolean => true
